import React, { useState } from 'react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-[#12101E] border-t border-[rgba(184,174,206,0.12)] py-8 px-5 relative z-10 text-center" data-id="element-154">
        <div className="max-w-[860px] mx-auto flex flex-col items-center gap-6" data-id="element-155">
          <div className="flex flex-col items-center" data-id="element-156">
            <h3 className="font-serif text-[clamp(1.3rem,4vw,1.6rem)] font-700 text-[var(--gold-l)] mb-1.5" data-id="element-157">
              33 Rituales para Soltar el Pasado
            </h3>
            <p className="text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] font-400" data-id="element-158">
              © 2026 Todos los derechos reservados.
            </p>
            <div className="mt-2 text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] font-400" data-id="element-159">
              <button onClick={() => setActiveModal('terms')} className="bg-transparent border-none cursor-pointer text-[var(--muted)] hover:text-[var(--text)] transition-colors" data-id="element-160">
                Términos y condiciones
              </button>{' '}
              ·{' '}
              <button onClick={() => setActiveModal('privacy')} className="bg-transparent border-none cursor-pointer text-[var(--muted)] hover:text-[var(--text)] transition-colors" data-id="element-161">
                Política de privacidad
              </button>
            </div>
          </div>
          <p className="max-w-[340px] text-[clamp(0.65rem,1.5vw,0.75rem)] text-[var(--muted)] leading-[1.9] font-400 text-center mx-auto" data-id="element-162">
            Este material es educativo y de desarrollo personal. No sustituye el
            diagnóstico, tratamiento o atención de un profesional de la salud
            mental.
          </p>
        </div>

        {/* Modal */}
        {activeModal && <div className="fixed inset-0 z-[9999] flex items-center justify-center p-5 bg-[rgba(26,22,40,0.85)] backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-163">
            <div className="relative w-full max-w-[600px] max-h-[80vh] overflow-y-auto rounded-[20px] p-8 md:p-10 text-center bg-[var(--bg3)] border border-[rgba(184,174,206,0.2)] shadow-[0_24px_64px_rgba(0,0,0,0.5)]" onClick={e => e.stopPropagation()} data-id="element-164">
              {/* Close button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center border-none cursor-pointer text-lg leading-none bg-[var(--bg2)] text-[var(--text)] hover:bg-[var(--lila)] transition-colors" data-id="element-165">
                ×
              </button>

              <h3 className="font-serif font-700 mb-6 text-[clamp(1.3rem,4vw,1.6rem)] text-white" data-id="element-166">
                {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
              </h3>

              <div className="text-[clamp(1.05rem,3vw,1.2rem)] leading-[1.9] space-y-4 text-[var(--text)] font-400 text-left" data-id="element-167">
                {activeModal === 'terms' ? <>
                    <p data-id="element-168">
                      <strong className="text-white font-medium" data-id="element-169">
                        1. Aceptación de los términos
                      </strong>
                    </p>
                    <p data-id="element-170">
                      Al adquirir el Kit Digital "33 Rituales para Soltar el
                      Pasado", aceptás estos términos y condiciones en su
                      totalidad. Si no estás de acuerdo con alguno de estos
                      términos, te pedimos que no realices la compra.
                    </p>

                    <p data-id="element-171">
                      <strong className="text-white font-medium" data-id="element-172">
                        2. Producto digital
                      </strong>
                    </p>
                    <p data-id="element-173">
                      Este producto es un kit digital descargable en formato
                      PDF. Una vez realizada la compra, recibirás acceso
                      inmediato al material a través de un enlace de descarga
                      enviado a tu correo electrónico.
                    </p>

                    <p data-id="element-174">
                      <strong className="text-white font-medium" data-id="element-175">
                        3. Uso personal
                      </strong>
                    </p>
                    <p data-id="element-176">
                      El contenido del kit es para uso personal y exclusivo del
                      comprador. Queda prohibida la reproducción, distribución,
                      reventa o compartición del material sin autorización
                      expresa.
                    </p>

                    <p data-id="element-177">
                      <strong className="text-white font-medium" data-id="element-178">
                        4. Garantía de devolución
                      </strong>
                    </p>
                    <p data-id="element-179">
                      Ofrecemos una garantía de devolución de 7 días desde la
                      fecha de compra. Si no estás satisfecha con el producto,
                      podés solicitar el reembolso completo dentro de ese plazo
                      sin necesidad de justificación.
                    </p>

                    <p data-id="element-180">
                      <strong className="text-white font-medium" data-id="element-181">
                        5. Limitación de responsabilidad
                      </strong>
                    </p>
                    <p data-id="element-182">
                      Este producto es una herramienta de apoyo emocional y no
                      reemplaza la atención psicológica o psiquiátrica
                      profesional. No nos hacemos responsables por los
                      resultados individuales de cada usuario.
                    </p>

                    <p data-id="element-183">
                      <strong className="text-white font-medium" data-id="element-184">
                        6. Propiedad intelectual
                      </strong>
                    </p>
                    <p data-id="element-185">
                      Todo el contenido del kit, incluyendo textos, diseños y
                      metodologías, está protegido por derechos de autor.
                      Cualquier uso no autorizado será perseguido legalmente.
                    </p>
                  </> : <>
                    <p data-id="element-186">
                      <strong className="text-white font-medium" data-id="element-187">
                        1. Información que recopilamos
                      </strong>
                    </p>
                    <p data-id="element-188">
                      Recopilamos únicamente la información necesaria para
                      procesar tu compra: nombre, dirección de correo
                      electrónico y datos de pago. No almacenamos información de
                      tarjetas de crédito.
                    </p>

                    <p data-id="element-189">
                      <strong className="text-white font-medium" data-id="element-190">
                        2. Uso de la información
                      </strong>
                    </p>
                    <p data-id="element-191">
                      Tu información personal se utiliza exclusivamente para:
                      procesar tu pedido, enviarte el material adquirido y
                      comunicarnos contigo en caso de ser necesario respecto a
                      tu compra.
                    </p>

                    <p data-id="element-192">
                      <strong className="text-white font-medium" data-id="element-193">
                        3. Protección de datos
                      </strong>
                    </p>
                    <p data-id="element-194">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, alteración o destrucción.
                    </p>

                    <p data-id="element-195">
                      <strong className="text-white font-medium" data-id="element-196">
                        4. Compartición con terceros
                      </strong>
                    </p>
                    <p data-id="element-197">
                      No vendemos, intercambiamos ni transferimos tu información
                      personal a terceros. La única excepción son los
                      proveedores de servicios de pago necesarios para procesar
                      tu transacción.
                    </p>

                    <p data-id="element-198">
                      <strong className="text-white font-medium" data-id="element-199">
                        5. Cookies
                      </strong>
                    </p>
                    <p data-id="element-200">
                      Nuestro sitio puede utilizar cookies para mejorar tu
                      experiencia de navegación. Podés configurar tu navegador
                      para rechazar cookies, aunque esto podría afectar algunas
                      funcionalidades.
                    </p>

                    <p data-id="element-201">
                      <strong className="text-white font-medium" data-id="element-202">
                        6. Tus derechos
                      </strong>
                    </p>
                    <p data-id="element-203">
                      Tenés derecho a acceder, rectificar o eliminar tu
                      información personal en cualquier momento. Para ejercer
                      estos derechos, contactanos a través de nuestro correo
                      electrónico.
                    </p>

                    <p data-id="element-204">
                      <strong className="text-white font-medium" data-id="element-205">
                        7. Cambios en la política
                      </strong>
                    </p>
                    <p data-id="element-206">
                      Nos reservamos el derecho de actualizar esta política de
                      privacidad en cualquier momento. Los cambios serán
                      publicados en esta página.
                    </p>
                  </>}
              </div>
            </div>
          </div>}
      </footer>
    </>;
}